import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiUrl } from "../../utils/apiURL";

export const orderApi = createApi({
  reducerPath: "orderApi",
  tagTypes: ["OrdersApii"],
  // keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: apiUrl,

    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token
        ? getState().auth.token
        : getState().auth.technicianToken;
      if (token) {
        // include token in req header
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllOrders: builder.query({
      query: (params = {}) => {
        // Default exclude_type if not provided
        const { exclude_type = "Service", ...otherParams } = params;

        // Build the URL with query parameters
        let url = `orders/?exclude_type=${exclude_type}`;

        // Add other parameters if they exist
        Object.entries(otherParams).forEach(([key, value]) => {
          if (value !== undefined) {
            // For arrays, stringify them here
            const paramValue = Array.isArray(value)
              ? JSON.stringify(value)
              : value;
            url += `&${key}=${paramValue}`;
          }
        });

        return url;
      },
    }),
    getOrder: builder.query({
      query: (id) => `orders/${id}`,
    }),
    getProductsStatus: builder.query({
      query: (params) => {
        if (!params) {
          return "products-delivery-status"; // Default: current year (2025)
        }

        // For "all" data option
        if (params.date === "all") {
          return "products-delivery-status?date=all";
        }

        return "products-delivery-status";
      },
    }),
  }),
});

export const {
  useGetAllOrdersQuery,
  useGetOrderQuery,
  useGetProductsStatusQuery,
} = orderApi;
